import * as React from 'react';
import './App.css';
import { initMain } from './com/sixdee/crbtportal/main';

class App extends React.Component 
{
  constructor(props: any)
  {
    super(props);
    
    initMain();
    // initLandingPageMain();
  }
  render()
  {
    return <div/>;
  }

/* 
<div className="col-3">
  <div>
    <li>The Flight</li>
    <li>The City</li>
    <li>The Island</li>
    <li>The Food</li>
  </div>
</div>

<div className="col-9">
  <h1>The City</h1>
  <p>Chania is the capital of the Chania region on the island of Crete. The city can be divided in two parts, the old town and the modern city.</p>
  <p>Resize the browser window to see how the content respond to the resizing.</p>
  {
    
  }
  <button/>
  <img src="/assets/images/delete.svg"/>
</div>

</div>

    );
  } */
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx